import { useToast } from "primevue/usetoast";
import { useI18n } from "vue-i18n";

interface AuthAck {
  seriale?: string;
}

// Quando un quadro locale si autentica (evento socket `auth_ack`) mostra un avviso «dispositivo X autenticato». Va chiamato
// nel layout: l'ascolto vale finché il layout è montato.
export function useAvvisoDispositivo(): void {
  const { socket } = useSocket() as { socket?: { on: (e: string, f: (d: AuthAck) => void) => void; off: (e: string, f?: (d: AuthAck) => void) => void } };
  const toast = useToast();
  const { t } = useI18n();

  const alRicevere = (dati?: AuthAck): void => {
    const seriale = dati?.seriale;
    if (!seriale) return;
    toast.add({
      group: "device",
      life: 3000,
      severity: "info",
      summary: t("layout.dispositivo.autenticazione_ricevuta"),
      detail: t("layout.dispositivo.autenticato", { seriale }),
    });
  };

  onMounted(() => {
    socket?.off("auth_ack", alRicevere);
    socket?.on("auth_ack", alRicevere);
  });
  onBeforeUnmount(() => socket?.off("auth_ack", alRicevere));
}
